import { Component, EventEmitter, Input, Output } from '@angular/core';


/**
 * Tamanhos padrão do modal:
 * - small: 400px - Para confirmações, alertas, formulários simples
 * - medium: 600px - Para formulários médios, detalhes
 * - large: 900px - Para formulários complexos, tabelas, listagens
 * - flex: Tamanho customizado via input 'largura' (pode ser px, %, vw)
 */
export type ModalSize = 'small' | 'medium' | 'large' | 'flex';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  @Input() titulo: string = '';
  @Input() isOpen: boolean = false;
  @Input() size: ModalSize = 'medium'; // Tamanho padrão
  @Input() largura: string = '600px'; // Usado quando size='flex'
  @Input() compacto: boolean = false; // Header compacto para modais de vídeo
  @Input() permitirFullscreen: boolean = false; // Permite toggle fullscreen
  @Output() fechar = new EventEmitter<void>();

  isFullscreen = false;

  // Tamanhos padrão em pixels
  private readonly sizeMap: Record<Exclude<ModalSize, 'flex'>, string> = {
    small: '400px',
    medium: '600px',
    large: '900px'
  };

  /**
   * Retorna a largura do modal baseado no tamanho selecionado
   */
  getModalWidth(): string {
    if (this.isFullscreen) return '100%';
    if (this.size === 'flex') return this.largura;
    return this.sizeMap[this.size];
  }

  onClose(): void {
    this.fechar.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;
  }
}
